<template>
  <div
    v-if="post"
    class="scroll-wrapper"
  >
    <b-form-group label="Post Title">
      <b-input
        v-model="post.title"
        placeholder="Your Title..."
      />
      <div
        v-if="error && !post.title.length"
        class="text-danger mt-1"
      >
        Title field is required.
      </div>
    </b-form-group>


    <b-form-group label="Featured Image">
      <image-upload
        :image="post.preview"
        :no-delete="false"
        disable-settigns
        @uploaded-src="handleSetCover"
      />
      <div
        v-if="error && !post.preview.src"
        class="text-danger mt-1"
      >
        Preview is required.
      </div>
    </b-form-group>

    <b-form-group label="Description">
      <b-textarea
        v-model="post.description"
        rows="4"
      />
      <div
        v-if="error && !post.description.length"
        class="text-danger mt-1"
      >
        Description is required.
      </div>
    </b-form-group>

    <post-categories v-model="post.categories">
      <div
        v-if="error && !post.categories.length && post.show_categories"
        class="text-danger"
      >
        Category is required.
      </div>
    </post-categories>

    <post-settings-authors :post="post">
      <div
        v-if="error && !post.author_id && post.show_author"
        class="text-danger"
      >
        Author is required.
      </div>
    </post-settings-authors>

    <page-password-select :page="post" />

    <post-seo
      :post="post"
      :project="project"
    />

    <b-form-group>
      <div class="flex items-center justify-between">
        <label
          class="mb-0 pb-0 cursor-pointer"
          for="post_seo_index"
        >
          Sitemap Indexing
        </label>

        <b-checkbox
          id="post_seo_index"
          v-model="post.seo_index"
          class="mt-0"
          switch
        />
      </div>
      <i class="text-[12px]">Show this page in the auto-generated sitemap.</i>
    </b-form-group>

    <b-form-group>
      <div class="flex items-center justify-between">
        <label
          class="mb-0 pb-0 cursor-pointer"
          for="comments_moderation"
        >
          Comments Moderation
        </label>

        <b-checkbox
          id="comments_moderation"
          v-model="post.comments_moderation"
          class="mt-0"
          switch
        />
      </div>
      <!-- <i class="text-[12px]">Show this page in the auto-generated sitemap.</i> -->
    </b-form-group>

    <!--    <b-form-group>-->
    <!--      <div class="text-[13px] text-[#4F4F4F] mb-2">-->
    <!--        Who can leave comments?-->
    <!--      </div>-->

    <!--      <b-form-radio-group-->
    <!--        :options="[{value: 0, text: 'Members Only'}, {value: 1, text: 'Everyone'}]"-->
    <!--      />-->
    <!--    </b-form-group>-->

    <!--    <b-form-group>-->
    <!--      <b-form-group>-->
    <!--        <div class="d-flex align-items-center mb-3">-->
    <!--          <svg-->
    <!--            class="mr-3"-->
    <!--            fill="none"-->
    <!--            height="23"-->
    <!--            viewBox="0 0 17 23"-->
    <!--            width="17"-->
    <!--            xmlns="http://www.w3.org/2000/svg"-->
    <!--          >-->
    <!--            <path-->
    <!--              d="M16.3169 6.64605L10.7924 1.12157C10.7146 1.04372 10.6091 1 10.4989 1H2.71445C1.76908 1 1 1.76908 1 2.71445V20.2855C1 21.2309 1.76908 22 2.71445 22H14.724C15.6694 22 16.4384 21.2309 16.4384 20.2855V6.93951C16.4384 6.82947 16.3947 6.72385 16.3169 6.64605ZM10.914 2.41705L15.0214 6.52439H11.7983C11.3107 6.52439 10.914 6.12769 10.914 5.64002V2.41705H10.914ZM15.6084 20.2855C15.6084 20.7732 15.2117 21.1699 14.724 21.1699H2.71445C2.22682 21.1699 1.83007 20.7732 1.83007 20.2855V2.71445C1.83007 2.22682 2.22682 1.83007 2.71445 1.83007H10.0839V5.6401C10.0839 6.58547 10.8529 7.35455 11.7983 7.35455H15.6084V20.2855V20.2855Z"-->
    <!--              fill="#6E747A"-->
    <!--              stroke="#6E747A"-->
    <!--              stroke-width="0.5"-->
    <!--            />-->
    <!--            <path-->
    <!--              d="M12.0407 11.5415H5.40039C5.17119 11.5415 4.98535 11.7273 4.98535 11.9565C4.98535 12.1857 5.17119 12.3716 5.40039 12.3716H12.0407C12.27 12.3716 12.4558 12.1857 12.4558 11.9565C12.4558 11.7273 12.27 11.5415 12.0407 11.5415Z"-->
    <!--              fill="#6E747A"-->
    <!--            />-->
    <!--            <path-->
    <!--              d="M12.0407 13.3953H5.40039C5.17119 13.3953 4.98535 13.5811 4.98535 13.8103C4.98535 14.0395 5.17119 14.2253 5.40039 14.2253H12.0407C12.27 14.2253 12.4558 14.0395 12.4558 13.8103C12.4558 13.5811 12.27 13.3953 12.0407 13.3953Z"-->
    <!--              fill="#6E747A"-->
    <!--            />-->
    <!--            <path-->
    <!--              d="M12.0407 15.249H5.40039C5.17119 15.249 4.98535 15.4349 4.98535 15.6641C4.98535 15.8933 5.17119 16.0791 5.40039 16.0791H12.0407C12.27 16.0791 12.4558 15.8933 12.4558 15.6641C12.4558 15.4349 12.27 15.249 12.0407 15.249Z"-->
    <!--              fill="#6E747A"-->
    <!--            />-->
    <!--            <path-->
    <!--              d="M9.88262 17.1028H5.40039C5.17119 17.1028 4.98535 17.2886 4.98535 17.5178C4.98535 17.747 5.17119 17.9329 5.40039 17.9329H9.88262C10.1119 17.9329 10.2977 17.747 10.2977 17.5178C10.2977 17.2886 10.1119 17.1028 9.88262 17.1028Z"-->
    <!--              fill="#6E747A"-->
    <!--            />-->
    <!--          </svg>-->

    <!--          <h6 class="mb-0">-->
    <!--            Status: <b class="text-capitalize">{{ post.status_code }}</b>-->
    <!--          </h6>-->
    <!--        </div>-->

    <!--        <template v-if="(!post.id && post.status_code !== 'publish') || shedule || post.status_code === 'draft'">-->
    <!--          <div class="d-flex align-items-center flex-nowrap">-->
    <!--            <svg-->
    <!--              class="mr-3"-->
    <!--              fill="none"-->
    <!--              height="19"-->
    <!--              viewBox="0 0 18 19"-->
    <!--              width="18"-->
    <!--              xmlns="http://www.w3.org/2000/svg"-->
    <!--            >-->
    <!--              <path-->
    <!--                d="M16.0714 2.79557H14.1429V1.50987C14.1429 1.15482 13.855 0.867004 13.5 0.867004C13.1449 0.867004 12.8571 1.15482 12.8571 1.50987V2.79557H5.14284V1.50987C5.14284 1.15482 4.85502 0.867004 4.50001 0.867004C4.14499 0.867004 3.85714 1.15482 3.85714 1.50987V2.79557H1.92857C0.863449 2.79557 0 3.65902 0 4.72414V16.9384C0 18.0036 0.863449 18.867 1.92857 18.867H16.0714C17.1365 18.867 18 18.0036 18 16.9384V4.72414C18 3.65902 17.1365 2.79557 16.0714 2.79557ZM16.7143 16.9384C16.7143 17.2935 16.4264 17.5813 16.0714 17.5813H1.92857C1.57352 17.5813 1.2857 17.2935 1.2857 16.9384V8.58128H16.7143V16.9384ZM16.7143 7.29558H1.2857V4.72414C1.2857 4.36909 1.57352 4.08128 1.92857 4.08128H3.85714V5.36698C3.85714 5.72203 4.14496 6.00985 4.50001 6.00985C4.85506 6.00985 5.14288 5.72203 5.14288 5.36698V4.08128H12.8572V5.36698C12.8572 5.72203 13.145 6.00985 13.5 6.00985C13.8551 6.00985 14.1429 5.72203 14.1429 5.36698V4.08128H16.0715C16.4265 4.08128 16.7143 4.36909 16.7143 4.72414V7.29558H16.7143Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M5.14293 9.86699H3.85722C3.50217 9.86699 3.21436 10.1548 3.21436 10.5099C3.21436 10.8649 3.50217 11.1527 3.85722 11.1527H5.14293C5.49798 11.1527 5.78579 10.8649 5.78579 10.5099C5.78579 10.1548 5.49798 9.86699 5.14293 9.86699Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M9.64293 9.86699H8.35722C8.00217 9.86699 7.71436 10.1548 7.71436 10.5099C7.71436 10.8649 8.00217 11.1527 8.35722 11.1527H9.64293C9.99798 11.1527 10.2858 10.8649 10.2858 10.5099C10.2858 10.1548 9.99798 9.86699 9.64293 9.86699Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M14.1429 9.86699H12.8572C12.5022 9.86699 12.2144 10.1548 12.2144 10.5099C12.2144 10.8649 12.5022 11.1527 12.8572 11.1527H14.1429C14.498 11.1527 14.7858 10.8649 14.7858 10.5099C14.7858 10.1548 14.4979 9.86699 14.1429 9.86699Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M5.14293 12.4384H3.85722C3.50217 12.4384 3.21436 12.7262 3.21436 13.0813C3.21436 13.4364 3.50217 13.7242 3.85722 13.7242H5.14293C5.49798 13.7242 5.78579 13.4364 5.78579 13.0813C5.78579 12.7262 5.49798 12.4384 5.14293 12.4384Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M9.64293 12.4384H8.35722C8.00217 12.4384 7.71436 12.7262 7.71436 13.0813C7.71436 13.4364 8.00217 13.7242 8.35722 13.7242H9.64293C9.99798 13.7242 10.2858 13.4364 10.2858 13.0813C10.2858 12.7262 9.99798 12.4384 9.64293 12.4384Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M14.1429 12.4384H12.8572C12.5022 12.4384 12.2144 12.7262 12.2144 13.0813C12.2144 13.4364 12.5022 13.7242 12.8572 13.7242H14.1429C14.498 13.7242 14.7858 13.4364 14.7858 13.0813C14.7858 12.7262 14.4979 12.4384 14.1429 12.4384Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M5.14293 15.0099H3.85722C3.50217 15.0099 3.21436 15.2977 3.21436 15.6527C3.21436 16.0078 3.50217 16.2956 3.85722 16.2956H5.14293C5.49798 16.2956 5.78579 16.0077 5.78579 15.6527C5.78579 15.2976 5.49798 15.0099 5.14293 15.0099Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M9.64293 15.0099H8.35722C8.00217 15.0099 7.71436 15.2977 7.71436 15.6527C7.71436 16.0078 8.00217 16.2956 8.35722 16.2956H9.64293C9.99798 16.2956 10.2858 16.0078 10.2858 15.6527C10.2858 15.2977 9.99798 15.0099 9.64293 15.0099Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M14.1429 15.0099H12.8572C12.5022 15.0099 12.2144 15.2977 12.2144 15.6527C12.2144 16.0078 12.5022 16.2956 12.8572 16.2956H14.1429C14.498 16.2956 14.7858 16.0078 14.7858 15.6527C14.7858 15.2977 14.4979 15.0099 14.1429 15.0099Z"-->
    <!--                fill="#6E747A"-->
    <!--              />-->
    <!--            </svg>-->

    <!--            <h6-->
    <!--              v-if="!dateEdit"-->
    <!--              class="mb-0"-->
    <!--            >-->
    <!--              Publish <b v-text="post.fromDate || 'immediately'" />-->
    <!--              <b-link-->
    <!--                class="text-primary ml-2"-->
    <!--                variant="primary"-->
    <!--                @click="dateEdit = true"-->
    <!--              >-->
    <!--                Edit-->
    <!--              </b-link>-->
    <!--            </h6>-->
    <!--            <date-picker-->
    <!--              v-else-->
    <!--              v-model="fromDate"-->
    <!--              :clearable="false"-->
    <!--              :disabled-date="disabledBeforeToday"-->
    <!--              class="w-100"-->
    <!--              format="YYYY-MM-DD HH:mm"-->
    <!--              input-class="form-control"-->
    <!--              type="datetime"-->
    <!--              value-type="format"-->
    <!--            />-->
    <!--          </div>-->

    <!--          <div-->
    <!--            v-if="dateEdit"-->
    <!--            class="d-flex align-items-center justify-content-end mt-2"-->
    <!--          >-->
    <!--            <b-btn-->
    <!--              class="mr-2"-->
    <!--              size="sm"-->
    <!--              variant="secondary"-->
    <!--              @click="immediately"-->
    <!--            >-->
    <!--              Immediately-->
    <!--            </b-btn>-->
    <!--            <b-btn-->
    <!--              size="sm"-->
    <!--              variant="primary"-->
    <!--              @click="saveDate"-->
    <!--            >-->
    <!--              Save-->
    <!--            </b-btn>-->
    <!--          </div>-->
    <!--        </template>-->

    <!--        <div-->
    <!--          v-if="post.status_code === 'publish'"-->
    <!--          class="mt-4"-->
    <!--        >-->
    <!--          <b-btn-->
    <!--            block-->
    <!--            variant="secondary"-->
    <!--            @click="unpublish"-->
    <!--          >-->
    <!--            Unpublish-->
    <!--          </b-btn>-->
    <!--        </div>-->
    <!--      </b-form-group>-->
    <!--    </b-form-group>-->
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ImageUpload from '../../components/editor/utils/ImageUpload'
// import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import PostCategories from '../../components/builder/components/blog/PostCategories'
import PostSettingsAuthors from '../../components/builder/components/blog/modals/PostSettingsAuthors'
import moment from 'moment'
import PostSeo from '../../components/builder/components/blog/PostSeo'
import PagePasswordSelect from '../../components/editor/components/PagePasswordSelect'
import {toLocalTime} from '@/utils/helpers'
export default {
  name: 'PostSettings',
  components: {
    PagePasswordSelect,
    PostSeo,
    PostSettingsAuthors,
    PostCategories,
    ImageUpload
    // DatePicker
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      dateEdit: false,
      error: false
    }
  },
  computed: {
    post: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    showDate: {
      get () {
        return this.post.show_date === null ? true : this.post.show_date
      },
      set (val) {
        this.$set(this.post, 'show_date', val)
      }
    },
    ...mapState('blogEditor', {
      postSubmit: state => state.submit
    }),
    ...mapState('authors', {
      authors: state => state.authors
    }),
    ...mapState('projects', {
      project: state => state.project
    }),
    shedule () {
      return this.postedDate.isAfter(moment())
    },
    postedDate () {
      return moment(this.post.post_date)
    },
    fromDate: {
      get () {
        return this.post.post_date ? toLocalTime(this.postedDate) : this.moment().format('YYYY-MM-DD HH:mm')
      },
      set (val) {
        this.post.post_date = val
      }
    }
  },
  watch: {
    postSubmit (val) {
      if (val) {
        this.submitPostFromHeaderButton(val)
      }
    }
  },
  mounted () {
    if (this.postSubmit) {
      this.submitPostFromHeaderButton(this.postSubmit)
    }
  },
  methods: {
    handleSetCover (src) {
      console.log(src)
      this.$set(this.post, 'cover', src)
    },
    unpublish () {
      this.edit('draft')

      this.$swal({
        icon: 'success',
        title: 'Done!',
        text: 'Post unpublished.',
        showConfirmButton: false,
        timer: 1500
      })
    },
    validate () {
      return new Promise((resolve, reject) => {
        if (!this.post.title.length || !this.post.description.length || !this.post.preview.src || !this.post.categories.length) {
          this.error = true
          return reject()
        }

        this.error = false
        return resolve()
      })
    },
    edit (status = 'publish') {
      if (status === 'publish') {
        this.$refs.postPublish.loading()
      }

      this.$store.dispatch('blogEditor/editPost', status)
        .then(({data}) => {
          if (status === 'publish') {
            this.$refs.postPublish.loading(data.data)
          }
          this.post.status = status
          this.post.status_code = status
        })
        .catch(() => {
          this.$refs.postPublish.close()
          this.$swal({
            icon: 'error',
            title: 'Server Error',
            text: 'All fields are required.',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    draft () {
      this.error = false
      this.loading = true

      if (this.post.id) {
        return this.edit('draft')
      }
      this.$store.dispatch('blogEditor/draftPost')
        .then(({data}) => {
          this.$store.dispatch('blogEditor/startEdit', data.data)

          this.$swal({
            icon: 'success',
            title: 'Post saved as draft',
            showConfirmButton: false,
            timer: 2000
          })
        })
        .catch(() => {
          this.$refs.postPublish.close()
          this.$swal({
            icon: 'error',
            title: 'Server Error',
            text: 'All fields are required.',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveDate () {
      if (this.fromDate !== this.moment().format('YYYY-MM-DD HH:mm')) {
        this.post.fromDate = this.fromDate
      }
      this.dateEdit = false
    },
    immediately () {
      this.post.post_date = this.moment().format('YYYY-MM-DD HH:mm')
      this.dateEdit = false
    },
    disabledBeforeToday (date) {
      const today = this.moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm')

      return this.moment(date).isBefore(today)
    }
  }
}
</script>

<style lang="scss">
.post-settings {
  background: #F9F8F8;
}
</style>
